var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-layout', [_c('a-layout-content', [_c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class.cui__layout__squaredBorders = _vm.settings.isSquaredBorders, _class.cui__layout__cardsShadow = _vm.settings.isCardShadow, _class.cui__layout__borderless = _vm.settings.isBorderless, _class[_vm.$style.white] = _vm.settings.authPagesColor === 'white', _class[_vm.$style.gray] = _vm.settings.authPagesColor === 'gray', _class),
    style: {
      backgroundImage: _vm.settings.authPagesColor === 'image' ? "url(resources/images/content/photos/7.jpg)" : 'none'
    }
  }, [_c('div', {
    class: (_class2 = {}, _class2[_vm.$style.topbar] = true, _class2[_vm.$style.topbarGray] = _vm.settings.isGrayTopbar, _class2)
  }, [_c('div', {
    class: _vm.$style.logoContainer
  }, [_c('div', {
    class: _vm.$style.logo
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": "/resources/images/logo.png"
    }
  })])])]), _c('div', {
    class: _vm.$style.containerInner
  }, [_c('transition', {
    attrs: {
      "name": _vm.settings.routerAnimation,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _c('div', {
    staticClass: "mt-auto pb-5 pt-5"
  }, [_c('ul', {
    staticClass: "list-unstyled d-flex mb-0 flex-wrap justify-content-center",
    class: [_vm.$style.footerNav]
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_vm._v("Terms of Use")])]), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript: void(0);"
    }
  }, [_vm._v("Support")])])]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(" Copyright © 2021 Belen | "), _c('a', {
    attrs: {
      "href": "https://www.belen-spot.me/privacy",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Privacy Policy")])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }